import React from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import useEvaluationActions from "../../../api/hooks/rater/evaluation";
import {
  evaluateComboState,
  evaluateIndexState,
  evaluationItemsState,
  evaluationListState,
  evaluationQuestionsListState,
  isCurrentIndexEvaluatedSelector,
} from "../../../recoil/rater/evaluation";
import { EVALUATION_ITEM_TYPE } from "../../../submodules/enum/type";

const EvaluationQuestionsList = ({ readOnly = false, evaluated = false }) => {
  const isCurrentIndexEvaluated = useRecoilValue(
    isCurrentIndexEvaluatedSelector
  );
  const evaluationActions = useEvaluationActions();
  //문항 번호
  const [evaluateIndex, setEvaluateIndex] = useRecoilState(evaluateIndexState);

  //콤보 번호
  const [evaluateCombo, setEvaluateCombo] = useRecoilState(evaluateComboState);

  const evaluationQuestionsList = useRecoilValue(evaluationQuestionsListState);
  const evaluationItems = useRecoilValue(evaluationItemsState);

  //내 평가 정보 객체
  const [evaluationList, setEvaluationList] =
    useRecoilState(evaluationListState);

  const evaluateUserAnswer = async () => {
    const res = await evaluationActions.evaluateUserAnswer();

    //평가 성공 시 로직, api 생기면 || true 삭제
    if (res?.data?.state === 200) {
      //내 답변 초기화
      setEvaluationList({});
      const index =
        (evaluateCombo.current - 1) * 3 + (evaluateIndex.current - 1);

      if (index + 1 === evaluationItems.length) {
        alert("모든 항목 평가 완료");
      } else {
        //문항 번호가 최대가 아닐때 문항 번호 + 1
        if (evaluateIndex.current < evaluateIndex.total) {
          setEvaluateIndex((old) => {
            return { ...old, current: old.current + 1 };
          });
        } else {
          //문항 번호가 최대일 때 콤보 번호 + 1, 문항 번호 초기화
          setEvaluateIndex((old) => {
            return {
              ...old,
              current: 1,
            };
          });
          setEvaluateCombo((old) => {
            return { ...old, current: old.current + 1 };
          });
        }
      }
    } else {
      //평가 실패 시 로직
    }
  };

  return (
    <div>
      <div className="evalation-box flex">
        <div className="evalation-title">
          <p>평가</p>
        </div>
        <div>
          <button
            type="button"
            className={`evalation-btn ${
              isCurrentIndexEvaluated || evaluated ? "complete" : "unrated"
            }`}
          >
            미평가
          </button>
          <button
            type="button"
            className={`evalation-btn ${
              isCurrentIndexEvaluated || evaluated ? "unrated" : "complete"
            }`}
          >
            평가완료
          </button>
        </div>
      </div>
      <div className="border-line"></div>
      {/* 평가 문항 생성 */}
      {evaluationQuestionsList?.map((question, i) => {
        return question.item_type === EVALUATION_ITEM_TYPE.CHOICE ? (
          <div className="question-box flex" key={i}>
            <div className="question-title">
              <p>{question.title}</p>
            </div>
            <div className="score-btn">
              {[1, 2, 3, 4, 5].map((item) => {
                return (
                  <button
                    disabled={readOnly}
                    type="button"
                    className={`score-number ${
                      question.score === item ||
                      evaluationList[evaluateIndex.current - 1]?.[i] === item
                        ? "active"
                        : ""
                    }`}
                    key={item}
                    onClick={() => {
                      let newList = evaluationList.map((ev, j) => {
                        return j === evaluateIndex.current - 1
                          ? {
                              ...evaluationList[evaluateIndex.current - 1],
                              [i]: item,
                              ratingList: evaluationList[
                                evaluateIndex.current - 1
                              ].ratingList.map((rating) => {
                                if (question.item_sn === rating.item_sn) {
                                  return { ...rating, score: item };
                                } else {
                                  return rating;
                                }
                              }),
                            }
                          : ev;
                      });
                      // console.log("newList", newList);
                      setEvaluationList(newList);
                    }}
                  >
                    {item}
                  </button>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="question-box flex" key={i}>
            <div className="question-title">
              <p>{question.title}</p>
            </div>
            <textarea
              value={
                readOnly === true
                  ? question.score
                  : evaluationList[evaluateIndex.current - 1]?.[i] === undefined
                  ? ""
                  : evaluationList[evaluateIndex.current - 1]?.[i]
              }
              className="q-insert-input motto-input mb-10"
              placeholder="< 평가 내용 입력 >"
              onChange={(e) => {
                let newList = evaluationList.map((ev, j) => {
                  return j === evaluateIndex.current - 1
                    ? {
                        ...evaluationList[evaluateIndex.current - 1],
                        [i]: e.target.value,
                        ratingList: evaluationList[
                          evaluateIndex.current - 1
                        ].ratingList.map((rating) => {
                          if (question.item_sn === rating.item_sn) {
                            return {
                              ...rating,
                              score: "< " + e.target.value + " >",
                            };
                          } else {
                            return rating;
                          }
                        }),
                      }
                    : ev;
                });
                // console.log("newList", newList);
                setEvaluationList(newList);
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default EvaluationQuestionsList;
